import React, { useState, useEffect } from "react";
import styles from "./SettingModal.module.css";
import { useLanguage } from "../../contexts/language/LanguageContext";
import { useSettings } from "../../contexts/setting/SettingContext";

const SettingModal = ({ isOpen, onClose, onSaved }) => {
  // Access the language context for localization
  const { t } = useLanguage();

  const { settings, updateSettings } = useSettings();

  // Local state to manage form inputs
  const [formData, setFormData] = useState({
    wsUrl: "",
    wsToken: "",
  });

  // Effect: Populate form data from localStorage when the modal opens
  useEffect(() => {
    if (isOpen) {
      setFormData({
        wsUrl: settings.wsUrl,
        wsToken: settings.wsToken,
      });
    }
  }, [isOpen]);

  // Handle input changes for all form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Save settings to localStorage and trigger callback
  const handleSave = () => {
    try {
      updateSettings(formData);

      // Trigger success callback (e.g., to reload the app or re-fetch config)
      if (onSaved) onSaved();

      onClose();
    } catch (error) {
      console.error("Error saving settings:", error);
      alert(t("modal_setting_save_error"));
    }
  };

  // Do not render if the modal is closed
  if (!isOpen) return null;

  return (
    <div className={styles["overlay"]}>
      <div className={styles["modal"]}>
        {/* --- Header Section --- */}
        <div className={styles["header"]}>
          <h3 className={styles["title"]}>{t("modal_setting_title")}</h3>
          <button className={styles["close-btn"]} onClick={onClose}>
            &times;
          </button>
        </div>

        {/* --- Body Section (Form Fields) --- */}
        <div className={styles["body"]}>
          {/* Field: WebSocket URL */}
          <div className={styles["form-group"]}>
            <label className={styles["label"]}>
              {t("modal_setting_label_ws")}
            </label>
            <input
              type="text"
              name="wsUrl"
              className={styles["input"]}
              value={formData.wsUrl}
              onChange={handleChange}
              placeholder={t("modal_setting_ph_ws")}
            />
          </div>

          {/* Field: WebSocket Token */}
          <div className={styles["form-group"]}>
            <label className={styles["label"]}>
              {t("modal_setting_label_token")}
            </label>
            <input
              type="password"
              name="wsToken"
              className={styles["input"]}
              value={formData.wsToken}
              onChange={handleChange}
              placeholder={t("modal_setting_ph_token")}
            />
          </div>

          {/* Note/Disclaimer */}
          <div className={styles["note"]}>{t("modal_setting_note")}</div>
        </div>

        {/* --- Footer Section (Actions) --- */}
        <div className={styles["footer"]}>
          <button
            className={`${styles["btn"]} ${styles["btn-cancel"]}`}
            onClick={onClose}
          >
            {t("modal_btn_cancel") || "Cancel"}
          </button>
          <button
            className={`${styles["btn"]} ${styles["btn-save"]}`}
            onClick={handleSave}
          >
            {t("modal_setting_btn_save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingModal;
